
import getBaseServiceOptions from './getBaseServiceOptions';

export default function getBaseModuleOptions(moduleName) {
    return {
        ...getBaseServiceOptions(),
        module: moduleName,
    };
}
